"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyMenuConfigurationLinksAppearence = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyMenuConfigurationLinksAppearence = (data, selected_link, multi_selected_links, set_data, t, additional_link_appearence_items, menu_for_style, selected_style_link, display_link_opacity, set_display_link_opacity) => {
    var _a;
    const parameter_to_modify = (menu_for_style) ? data.style_link : data.links;
    const selected_parameter = (menu_for_style) ? [data.style_link[selected_style_link]] : multi_selected_links.current;
    const dashChecked = () => {
        let dashChecked = true;
        selected_parameter.map(d => {
            dashChecked = (d.dashed) ? dashChecked : false;
        });
        return dashChecked;
    };
    const shiftCenter = () => {
        if (selected_parameter.length == 0) {
            return 0.5;
        }
        const idx = selected_parameter.length - 1;
        const current_link = selected_parameter[idx];
        return parseFloat(((current_link.left_horiz_shift + current_link.right_horiz_shift) / 2).toPrecision(2));
    };
    const shift = () => {
        if (selected_parameter.length == 0) {
            return 0.1;
        }
        const idx = selected_parameter.length - 1;
        const current_link = selected_parameter[idx];
        const the_shift = (current_link.right_horiz_shift - current_link.left_horiz_shift) / 2;
        return parseFloat(the_shift.toPrecision(2));
    };
    const linkOrientation = (param) => {
        let allChecked = true;
        switch (param) {
            case 'hh':
                selected_parameter.map(d => {
                    allChecked = (d.orientation == 'hh') ? allChecked : false;
                });
                return allChecked;
                break;
            case 'vv':
                selected_parameter.map(d => {
                    allChecked = (d.orientation == 'vv') ? allChecked : false;
                });
                return allChecked;
                break;
            case 'hv':
                selected_parameter.map(d => {
                    allChecked = (d.orientation == 'hv') ? allChecked : false;
                });
                return allChecked;
                break;
            case 'vh':
                selected_parameter.map(d => {
                    allChecked = (d.orientation == 'vh') ? allChecked : false;
                });
                return allChecked;
                break;
        }
    };
    const courbure = () => {
        let display_courbe = true;
        let courbe = 0.5;
        if (selected_parameter.length != 0) {
            courbe = selected_parameter[0].curvature;
        }
        selected_parameter.map((d) => {
            display_courbe = (d.curvature == courbe) ? display_courbe : false;
        });
        return (display_courbe) ? courbe : 0;
    };
    const linkType = (param) => {
        let allChecked = true;
        if (selected_parameter.length != 0) {
            switch (param) {
                case 'courbe':
                    selected_parameter.map(d => {
                        allChecked = (d.curved) ? allChecked : false;
                    });
                    break;
                case 'arrow':
                    selected_parameter.map(d => {
                        allChecked = (d.arrow) ? allChecked : false;
                    });
                    break;
                case 'recycle':
                    selected_parameter.map(d => {
                        allChecked = (d.recycling) ? allChecked : false;
                    });
                    break;
            }
            return allChecked;
        }
        else {
            return false;
        }
    };
    /* Formattage de l'affichage du menu attribut de flux */
    return react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "flux_attributes", title: t('Flux.apparence.apparence') },
        react_1.default.createElement(react_bootstrap_1.Form, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                        t('Flux.apparence.couleur'),
                        ":")),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Flux.apparence.tooltips.1', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Flux.apparence.tooltips.1' },
                            t('Flux.apparence.tooltips.couleur'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "color", value: (selected_parameter.length == 1) ? selected_parameter[0].color : '#ffffff', onChange: evt => {
                                // selected_parameter[0].color = evt.target.value
                                const color = evt.target.value;
                                selected_parameter.map(d => d.color = evt.target.value);
                                Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => d.color = color);
                                set_data(Object.assign({}, data));
                            } })))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                        t('Flux.apparence.opacity'),
                        ":")),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Flux.apparence.tooltips.1', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Flux.apparence.tooltips.1' },
                            t('Flux.apparence.tooltips.opacity'),
                            " ") },
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "number", max: 1, min: 0, step: 0.1, value: display_link_opacity, isInvalid: +display_link_opacity != ((_a = selected_parameter[0]) === null || _a === void 0 ? void 0 : _a.opacity), onChange: evt => {
                                    set_display_link_opacity(evt.target.value);
                                }, onBlur: (evt) => {
                                    Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => d.opacity = +evt.target.value);
                                    set_data(Object.assign({}, data));
                                } }),
                            react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: 'invalid' }, t('MEP.onBlur')))))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                        t('Flux.apparence.hach'),
                        ":")),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Flux.apparence.tooltips.2', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Flux.apparence.tooltips.2' },
                            t('Flux.apparence.tooltips.hach'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, type: "checkbox", checked: dashChecked(), onChange: evt => {
                                Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => d.dashed = evt.target.checked);
                                set_data(Object.assign({}, data));
                            } })))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                        t('Flux.apparence.of'),
                        ":")),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Flux.apparence.tooltips.3', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Flux.apparence.tooltips.3' },
                            t('Flux.apparence.tooltips.of_hh'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { name: 'orientation', type: 'checkbox', label: 'Horiz-Horiz', value: 'hh', checked: linkOrientation('hh'), onChange: evt => {
                                Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                    d.orientation = evt.target.value;
                                });
                                set_data(Object.assign({}, data));
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Flux.apparence.tooltips.4', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Flux.apparence.tooltips.4' },
                            t('Flux.apparence.tooltips.of_vv'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { name: 'orientation', type: 'checkbox', label: 'Vert-Vert', value: 'vv', checked: linkOrientation('vv'), onChange: evt => {
                                Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                    d.orientation = evt.target.value;
                                });
                                set_data(Object.assign({}, data));
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Flux.apparence.tooltips.5', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Flux.apparence.tooltips.5' },
                            t('Flux.apparence.tooltips.of_vh'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { name: 'orientation', type: 'checkbox', label: 'Vert-Horiz', value: 'vh', checked: linkOrientation('vh'), onChange: evt => {
                                Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                    d.orientation = evt.target.value;
                                });
                                set_data(Object.assign({}, data));
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.apparence.tooltips.6', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.apparence.tooltips.6' },
                            t('Flux.apparence.tooltips.of_hv'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { name: 'orientation', type: 'checkbox', label: 'Horiz-Vert', value: 'hv', checked: linkOrientation('hv'), onChange: evt => {
                                Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                    d.orientation = evt.target.value;
                                });
                                set_data(Object.assign({}, data));
                            } })))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Flux.apparence.pdc'))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.apparence.tooltips.7', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.apparence.tooltips.7' },
                            t('Flux.apparence.tooltips.pdc'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, max: 100, type: 'number', value: shiftCenter() * 100, disabled: (linkOrientation('hv') || linkOrientation('vh')), onChange: evt => {
                                const center = +evt.target.value / 100;
                                selected_parameter.forEach(d => {
                                    let shift_gap = (d.right_horiz_shift - d.left_horiz_shift) / 2;
                                    if (center - shift_gap < 0) {
                                        shift_gap = center;
                                    }
                                    if (center + shift_gap > 1) {
                                        shift_gap = 1 - center;
                                    }
                                    d.left_horiz_shift = center - shift_gap;
                                    d.right_horiz_shift = center + shift_gap;
                                });
                                set_data(Object.assign({}, data));
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 }, shiftCenter())),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Flux.apparence.eep'))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.apparence.tooltips.8', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.apparence.tooltips.8' },
                            t('Flux.apparence.tooltips.eep'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, max: 5, type: 'number', value: shift() * 100, disabled: (linkOrientation('hv') || linkOrientation('vh')), onChange: evt => {
                                const shift_gap = +evt.target.value / 100;
                                if (shift_gap > 0.5) {
                                    return;
                                }
                                selected_parameter.forEach(d => {
                                    let new_center_position = shiftCenter();
                                    if (new_center_position - shift_gap < 0) {
                                        new_center_position = shift_gap;
                                    }
                                    if (new_center_position + shift_gap > 1) {
                                        new_center_position = 1 - shift_gap;
                                    }
                                    d.left_horiz_shift = new_center_position - shift_gap;
                                    d.right_horiz_shift = new_center_position + shift_gap;
                                });
                                set_data(Object.assign({}, data));
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 }, shift())),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                        t('Flux.apparence.type'),
                        ":")),
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.apparence.tooltips.9', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.apparence.tooltips.9' },
                            t('Flux.apparence.tooltips.courbe'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: t('Flux.apparence.courbe'), checked: linkType('courbe'), onChange: evt => {
                                Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => d.curved = evt.target.checked);
                                set_data(Object.assign({}, data));
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.apparence.tooltips.10', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.apparence.tooltips.10' },
                            t('Flux.apparence.tooltips.fleche'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: t('Flux.apparence.fleche'), checked: linkType('arrow'), onChange: evt => {
                                Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => d.arrow = evt.target.checked);
                                set_data(Object.assign({}, data));
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.apparence.tooltips.11', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.apparence.tooltips.11' },
                            t('Flux.apparence.tooltips.recy'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: t('Flux.apparence.recy'), checked: linkType('recycle'), onChange: evt => {
                                Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                    d.recycling = evt.target.checked;
                                    d.left_horiz_shift = 0;
                                    d.right_horiz_shift = 0;
                                });
                                set_data(Object.assign({}, data));
                            } })))),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Flux.apparence.courbure'))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.apparence.tooltips.12', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.apparence.tooltips.12' },
                            t('Flux.apparence.tooltips.courbure'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, max: 1, step: 0.01, type: 'number', value: courbure(), onChange: evt => {
                                Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                    d.curvature = +evt.target.value;
                                });
                                set_data(Object.assign({}, data));
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 }, (selected_parameter.length > 0) ? selected_parameter[0].curvature : 0)),
            additional_link_appearence_items));
};
exports.SankeyMenuConfigurationLinksAppearence = SankeyMenuConfigurationLinksAppearence;
